import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
	paper: {
		padding: '20px',
		marginBottom: '30px',
	},
	counters: {
		maxWidth: '500px',
	},
	counter: {
		float: 'left',
		textAlign: 'center',
		padding: '10px',
	},
	counterDivider: {
		borderLeft: '2px solid #C4C4C4',
	},
	clearFix: {
		clear: 'both',
	},
	counterValue: {
		fontSize: '24px',
		fontWeight: 'bold',
	},
	counterField: {
		fontSize: '12px',
	},
}));

interface Props {
	totalNights: number
	totalReservations: number
	totalRevenue: number
}

interface CounterProps {
	field: string
	value: number | string
	divider?: boolean
}

export const CustomerLTV = (props: Props) => {
	const classes = useStyles();

	const Counter = (props: CounterProps) => {
		const className = props.divider === true
			? [classes.counter, classes.counterDivider].join(' ')
			: classes.counter;

		return (
			<div className={className}>
				<p className={classes.counterValue}>{props.value}</p>
				<p className={classes.counterField}>{props.field}</p>
			</div>
		);
	};

	return (
		<div className={classes.counters}>
			<Counter field="Nights stayed" value={props.totalNights} />
			<Counter field="Reservations" value={props.totalReservations} divider />
			<Counter field="Money spent" value={`€${props.totalRevenue}`} divider />
			<div className={classes.clearFix}></div>
		</div>
	);
};
